import { FccOperatorRoleType } from '@backoffice-frontend/graphql'
import {
  type AdRemoteOperationsArea,
  useOptionalAdRemoteOperationsArea,
} from './AdRemoteOperationsArea'

const remoteOperationsAreaOperatorRole: Record<
  AdRemoteOperationsArea,
  FccOperatorRoleType | undefined
> = {
  'ad-fleet-map': undefined,
  'rider-support': FccOperatorRoleType.RiderSupport,
  'remote-assistance-operator': FccOperatorRoleType.RemoteAssistanceOperator,
}

export const useRemoteOperationsAreaOperatorRole = ():
  | FccOperatorRoleType
  | undefined => {
  const remoteOperationsArea = useOptionalAdRemoteOperationsArea()
  return remoteOperationsArea
    ? remoteOperationsAreaOperatorRole[remoteOperationsArea]
    : undefined
}
